"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasePageConfigSchemaV1 = void 0;
const zod_1 = require("zod");
const LandingPageBuilder_1 = require("./LandingPageBuilder");
const sections_1 = require("./sections");
const IntroductionSection = zod_1.z.object({
    type: zod_1.z.literal('Introduction'),
    enabled: zod_1.z.literal(true),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().min(1, { message: 'Title is required' }).max(60, {
        message: 'Title is too long',
    }),
    subtitle: zod_1.z.string().min(1, { message: 'Subtitle is required' }).max(60, {
        message: 'Subtitle is too long',
    }),
    desc: zod_1.z.string().min(1, { message: 'Description is required' }),
    coverImage: zod_1.z.string().min(1, { message: 'Cover image is required' }),
    introVideo: zod_1.z.string().nullable(),
    primaryColor: zod_1.z.string(),
    priceBefore: zod_1.z.number().nullable(),
    logo: zod_1.z.string().optional(),
});
const ProgramStatsSection = zod_1.z.object({
    type: zod_1.z.literal('ProgramStats'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
});
const ReviewsSections = zod_1.z.object({
    type: zod_1.z.literal('Reviews'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().optional(),
    reviews: zod_1.z
        .array(zod_1.z.object({
        name: zod_1.z.string().min(1, { message: 'Name is required' }),
        text: zod_1.z.string().min(1, { message: 'Text is required' }),
    }))
        .optional()
        .default([]),
});
const TextSection2 = zod_1.z.object({
    type: zod_1.z.literal('TextSection2'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().min(1, { message: 'Title is required' }),
    desc: zod_1.z.string().min(1, { message: 'Description is required' }),
    bullets: zod_1.z
        .array(zod_1.z.object({
        text: zod_1.z.string(),
    }))
        .optional()
        .default([]),
    images: zod_1.z
        .array(zod_1.z.object({ url: zod_1.z.string().nullable().default(null) }))
        .optional(),
    rotateImages: zod_1.z.boolean().optional(),
});
const TextSection1 = zod_1.z.object({
    type: zod_1.z.literal('TextSection1'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().min(1, { message: 'Title is required' }),
    desc: zod_1.z.string().min(1, { message: 'Description is required' }),
    bullets: zod_1.z
        .array(zod_1.z.object({
        text: zod_1.z.string(),
    }))
        .optional()
        .default([]),
    coverImage: zod_1.z.string().min(1, { message: 'Cover image is required' }),
    introVideo: zod_1.z.string().nullable(),
});
const TestimonialsSection = zod_1.z.object({
    type: zod_1.z.literal('Testimonials'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string(),
    testimonials: zod_1.z
        .array(zod_1.z.object({
        video: zod_1.z.string().nullable().default(null),
        image: zod_1.z.string().nullable().default(null),
        name: zod_1.z.string().optional(),
        text: zod_1.z.string().optional(),
    }))
        .optional()
        .default([]),
});
const FaqsSection = zod_1.z.object({
    type: zod_1.z.literal('FAQs'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string(),
    faqs: zod_1.z
        .array(zod_1.z.object({
        question: zod_1.z.string(),
        answer: zod_1.z.string(),
    }))
        .optional()
        .default([]),
});
const WorkoutsSection = zod_1.z.object({
    type: zod_1.z.literal('Workouts'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string(),
    workoutIds: zod_1.z.array(zod_1.z.number()).optional(),
});
const FeaturesSection = zod_1.z.object({
    type: zod_1.z.literal('Features'),
    title: zod_1.z.string().optional(),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    remindersCoverImage: zod_1.z.string().nullable().default(null),
    streaksCoverImage: zod_1.z.string().nullable().default(null),
    workoutsCoverImage: zod_1.z.string().nullable().default(null),
    favoritesCoverImage: zod_1.z.string().nullable().default(null),
    lifetimeCoverImage: zod_1.z.string().nullable().default(null),
    streamCoverImage: zod_1.z.string().nullable().default(null),
});
const OTPFeaturesSection = zod_1.z.object({
    type: zod_1.z.literal('OTPFeatures'),
    title: zod_1.z.string().optional(),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    features: zod_1.z
        .array(zod_1.z.object({
        type: zod_1.z.union([
            zod_1.z.literal('reminders'),
            zod_1.z.literal('streaks'),
            zod_1.z.literal('tracking'),
            zod_1.z.literal('favorites'),
            zod_1.z.literal('videos'),
            zod_1.z.literal('notes'),
            zod_1.z.literal('stream'),
            zod_1.z.literal('offline'),
            zod_1.z.literal('playlist'),
            zod_1.z.literal('nutrition'),
            zod_1.z.literal('lifetime'),
        ]),
        name: zod_1.z.string(),
        image: zod_1.z.string(),
    }))
        .optional()
        .default([]),
});
const BioSection = zod_1.z.object({
    type: zod_1.z.literal('Bio'),
    enabled: zod_1.z.boolean(),
    bgColor: zod_1.z.string(),
    colorIndex: zod_1.z.number().optional(),
    title: zod_1.z.string().min(1, { message: 'Title is required' }),
    desc: zod_1.z.string().min(1, { message: 'Description is required' }),
    coverImage: zod_1.z.string().min(1, { message: 'Cover image is required' }),
    introVideo: zod_1.z.string().nullable(),
});
const allowDisabled = (schema) => {
    return zod_1.z.union([
        schema,
        zod_1.z.object({ enabled: zod_1.z.literal(false) }).passthrough(),
    ]);
};
const withCTA = (schema) => schema.extend({
    cta: zod_1.z
        .object({
        enabled: zod_1.z.boolean().optional(),
        customize: zod_1.z.boolean().optional(),
        text: zod_1.z.string().optional().nullable(),
        link: zod_1.z.string().optional().nullable(),
    })
        .optional(),
});
const IntroductionSectionWithCTA = withCTA(IntroductionSection);
const TextSection2WithCTA = withCTA(TextSection2);
const TextSection1WithCTA = withCTA(TextSection1);
exports.PurchasePageConfigSchemaV1 = zod_1.z.object({
    sections: zod_1.z.array(zod_1.z.union([
        IntroductionSectionWithCTA,
        allowDisabled(sections_1.EmailCaptureSection),
        allowDisabled(ProgramStatsSection),
        allowDisabled(TextSection1WithCTA),
        allowDisabled(TextSection2WithCTA),
        allowDisabled(FeaturesSection),
        allowDisabled(OTPFeaturesSection),
        allowDisabled(LandingPageBuilder_1.FeaturesNewSection),
        allowDisabled(WorkoutsSection),
        allowDisabled(BioSection),
        allowDisabled(ReviewsSections),
        allowDisabled(TestimonialsSection),
        allowDisabled(FaqsSection),
    ])),
});
